<div style="text-align:center" *ngIf="errors.length == 0">
  <div *ngIf="!webcamImage">
    <webcam [height]="380" [trigger]="triggerObservable" (imageCapture)="handleImage($event)" [allowCameraSwitch]="true"
      mirrorImage="never" [imageQuality]="1" (initError)="handleInitError($event)"></webcam>
  </div>
  <div class="after-taking-snapshot" *ngIf="webcamImage">
    <img [src]="webcamImage.imageAsDataUrl" />
  </div>
  <nz-space class="buttons-container">
    <nz-space-item *ngIf="!webcamImage">
      <button nz-button nzType="primary" (click)="triggerSnapshot();">
        <i nz-icon nzTheme="outline" nzType="camera"></i>
        {{'Take a picture' | locale}}</button>
    </nz-space-item>
    <nz-space-item *ngIf="webcamImage">
      <button nz-button nzType="primary" (click)="submitAndUpload()" [nzLoading]="isLoading">
        <i nz-icon nzTheme="outline" nzType="upload"></i>
        {{'Submit' | locale}}
      </button>
    </nz-space-item>
    <nz-space-item *ngIf="webcamImage">
      <button nz-button (click)="webcamImage = null;">
        <i nz-icon nzTheme="outline" nzType="redo"></i>
        {{'Retake picture' | locale}}
      </button>
    </nz-space-item>
  </nz-space>
</div>
<nz-result *ngIf="errors.length > 0" [nzTitle]="'Loading camera failed' | locale" nzStatus="error"
  [nzSubTitle]="'Please make sure to provide permission in the browser to access camera, and your camera device is available.' | locale">
  <div nz-result-content>
    <div class="desc">
      <h4 nz-title>{{'Messages' | locale}}</h4>
      <p nz-paragraph *ngFor="let error of errors">
        <i nz-icon nzType="close-circle"></i>
        {{error.message}}
      </p>
    </div>
  </div>
</nz-result>
